angular
  .module('promotionCode')
  .component('promotionCode', {
    template: require('./promotion-code.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function PromotionCodeViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $rootScope.mainmenu = 'coupons';
        $rootScope.menu = 'promotion';
        $scope.doLogout = $rootScope.gLogout;
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.coupons = {};
        this.total_count = 0;
        this.query = '';
        $resource(`${APIURL}/admin/promotion/coupons`).get({}).$promise
          .then((data) => {
            console.log(data.coupons);
            this.coupons = data.coupons;
            this.total_count = data.total_count;
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.paging = (page) => {
          $resource(`${APIURL}/admin/promotion/coupons`).get({ page: page - 1 },
            (data) => {
              console.log(data);
              this.coupons = data.coupons;
              this.total_count = data.total_count;
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.delete = (coupon) => {
          if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/promotion/coupons/${coupon.ID}`).delete({},
            () => {
              alert($translate.instant('삭제되었습니다'));
              this.coupons.splice(this.coupons.indexOf(coupon), 1);
              jQuery('#modal-coupon').removeClass('fade');
              jQuery('#modal-coupon').modal('hide');
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.showUser = (coupon) => {
          $resource(`${APIURL}/admin/promotion/coupons/${coupon.ID}/users`).get((data) => {
            this.couponUser = data.coupons;
            jQuery('#modal-coupon-user').modal('show');
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/promotion-code/promotion-code.component.js